<template>
  <Card
    :padding="false"
    :margins="false"
  >
    <template slot="header">
      Reports
    </template>
    <v-list>
      <!-- user links -->
      <v-list-tile
        v-for="item in items"
        v-if="item.visible()"
        :key="item.text"
        :to="item.path">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ item.text }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </Card>
</template>

<script>

export default {
  data () {
    return {
      items: [
        {
          icon: 'fa-columns',
          text: 'Gate',
          path: '/reports/gate',
          visible: () => this.assertSetting('viewReports', 1)
        },
        {
          icon: 'insert_chart',
          text: 'Financial',
          path: '/reports/financial',
          visible: () => this.assertSetting('viewFinancialReports', 1)
        },
        {
          icon: 'pie_chart',
          text: 'Utilization',
          path: '/reports/utilization',
          visible: () => this.assertSetting('viewReports', 1)
        },
        {
          icon: 'fa-file-invoice-dollar',
          text: 'Invoice Source',
          path: '/reports/invoiceSource',
          visible: () => this.assertSetting('viewReports', 1)
        },
        {
          icon: 'fa-file-export',
          text: 'Generate',
          path: '/reports/generate',
          visible: () => this.assertSetting('viewReports', 1)
        },
        {
          icon: 'fa-exclamation-triangle',
          text: 'Error Log',
          path: '/reports/Error',
          visible: () => this.assertSetting('developmentUtils', 1)
        }
      ]
    }
  }
}
</script>
